/* eslint-disable jira/filename-case */
import type { UserPreferenceType } from '@jira/global-pages__dashboard-user-preference/src/types.tsx';
import type { ReactGadgetGetInitialState } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import type { CustomReportGadgetData } from '../common/types.tsx';

const getInitialState: ReactGadgetGetInitialState<
	CustomReportGadgetData,
	UserPreferenceType[]
> = () =>
	Promise.resolve({
		intervalValue: '1',
		isCustom: 'false',
		projectValue: '0',
		refresh: 'false',
		reportValue: '0',
		gadgetContentTitle: '',
	});

export default getInitialState;
